/**
 * Todo valor monetário trafega em CENTAVOS (inteiro).
 * A conversão para reais acontece só na borda: aqui na exibição e no parse do input.
 */
const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatMoney = (cents: number | null | undefined): string =>
  BRL.format((cents ?? 0) / 100);

/** "1.234,56" ou "1234.56" → 123456 centavos. */
export const parseMoney = (input: string): number => {
  const normalized = input
    .replace(/[^\d,.-]/g, '')
    .replace(/\.(?=\d{3}\b)/g, '')
    .replace(',', '.');
  const value = Number.parseFloat(normalized);
  return Number.isFinite(value) ? Math.round(value * 100) : 0;
};

const DATE = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short' });
const DATE_TIME = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeStyle: 'short',
});

export const formatDate = (iso: string | null | undefined): string =>
  iso ? DATE.format(new Date(iso)) : '—';

export const formatDateTime = (iso: string | null | undefined): string =>
  iso ? DATE_TIME.format(new Date(iso)) : '—';

/** "há 3 dias" — usado no tempo em etapa e no histórico. */
export const formatRelative = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const diffMs = Date.now() - new Date(iso).getTime();
  const minutes = Math.round(diffMs / 60000);

  if (minutes < 1) return 'agora';
  if (minutes < 60) return `há ${minutes}min`;

  const hours = Math.round(minutes / 60);
  if (hours < 24) return `há ${hours}h`;

  const days = Math.round(hours / 24);
  if (days < 30) return `há ${days}d`;

  const months = Math.round(days / 30);
  return `há ${months}m`;
};

/** Dias corridos desde a data — "dias em aberto" do negócio. */
export const daysSince = (iso: string | null | undefined): number => {
  if (!iso) return 0;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000);
};

/** Link de conversa a partir do telefone só-dígitos do lead. */
export const whatsappLink = (rawPhone: string | null | undefined): string | null =>
  rawPhone ? `https://wa.me/${rawPhone}` : null;

export const initials = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
/** "19/10/2026" — formato das colunas "Data de criação" dos cadastros. */
export const formatShortDate = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleDateString('pt-BR') : '—';

/** A data já passou? (atividade atrasada no card). */
export const isPast = (iso: string | null | undefined): boolean =>
  Boolean(iso) && new Date(iso as string).getTime() < Date.now();
